import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-hub',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './admin-hub.component.html',
  styleUrl: './admin-hub.component.css',
})
export class AdminHubComponent {}
